import React from "react";
import { useTranslation } from 'react-i18next';

import "./WelcomeModal.scss";

import WelcomeImg from "static/images/welcome_img.svg"
import UniversalButton from "../../uiComponents/UniversalButton";

const WelcomeModal = ({
    onActionClick,
}) => {
    const { t } = useTranslation();

    return (
        <div className="welcome-modal">
            <img
                className="welcome-modal_img"
                src={WelcomeImg}
            />

            <div
                className="welcome-modal__content"
            >
                <p
                    className="welcome-modal__content_title"
                >
                    {t('welcome_to_bimsearch')}
                </p>

                <p
                    className="welcome-modal__content_text"
                >
                    {t('projects_displayed_text')}, <br/> {t('open_model_start_searching')}!
                </p>
            </div>

            <div
                className="welcome-modal__button_container"
            >
                <UniversalButton
                    label={t('lets_start')}
                    size="lg"
                    labelColor="white"
                    labelHoverColor="white"
                    backgroundColor="orange"
                    backgroundHoverColor="orange-light"
                    onClick={onActionClick}
                />
            </div>
            <p
                className="welcome-modal__content_text-note"
            >
                {t('click_question_mark_text')}
            </p>
        </div>
    );
};

export default WelcomeModal;
